import styled from 'styled-components'

const IconLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  z-index: ${({ theme }) => theme.zindex.overlay};
  border: 1px solid darkgray;
  background-color: ${({ active, theme }) => (active ? theme.colors.primary : 'white')};
  width: ${({ small }) => (small ? '40px' : '56px')};
  height: ${({ small }) => (small ? '40px' : '56px')};
  margin: 0 0 10px 10px;
  box-shadow: ${({ theme }) => theme.defaultBoxShadow};

  &:hover {
    cursor: pointer;
  }
`

export default IconLink
